<template>
  <QuadroPrincipal
    :titulo="segmentoSelecionado.id_imposto == 100 ? 'CARGA LÍQUIDA' : 'SEGMENTO'"
    :classe="classe"
  >
    <RegistrosSegmentoCargaLiquida
      :classe="classe"
      :segmento="segmento"
      :seleciona="seleciona"
      :segmentoSelecionado="segmentoSelecionado"
      :selecionouSegmento="selecionouSegmento"
      :edita="edita"
      :loading="loading"
    />
  </QuadroPrincipal>
</template>

<script>
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import RegistrosSegmentoCargaLiquida from "@/components/RegistrosSegmentoCargaLiquida/RegistrosSegmentoCargaLiquida.vue";

export default {
  name: "QuadroSegmentoCargaLiquida",

  props: {
    classe: String,
    loading: Boolean,
    segmento: Object | Array,
    seleciona: Function,
    segmentoSelecionado: Object,
    selecionouSegmento: Boolean,
    edita: Function,
    cargaTributariaEfetiva: Number
  },

  components: {
    QuadroPrincipal,
    RegistrosSegmentoCargaLiquida
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped></style>
